module.exports = __webpack_public_path__ + "static/media/kimdoncharliecar.1bfe9630.png";